export default __webpack_public_path__ + "static/media/050-cash register.0b9c46ac.svg";